export const routersWithoutMainLayout = ['/auth', '/sign-up', '/reset-password', '/not-found']